import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DeheadingPeelingRequest } from './deheading-peeling-dto';

export class DeheadingPeelingResponseModel extends GlobalResponseObject{
    data?: DeheadingPeelingRequest[];

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: DeheadingPeelingRequest[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}
